export default function OfferTypesPriority() {
  // An array with offer's types set by priority
  return ['OST5', 'OST3', 'OST2', 'OST8', 'OST7', 'OST1', 'OST4', 'OST9', 'OST6'];
}
